import { BridgeStatus } from "../api";

export function BridgeBadge({ bridge }: { bridge: BridgeStatus | null }) {
  const connected = !!bridge?.connected;
  const color = connected ? "bg-ok" : "bg-bad";
  const label = connected
    ? `MT5 ${bridge && bridge.connected ? bridge.mt5_login ?? "?" : "?"}`
    : "bridge offline";
  return (
    <span className="inline-flex items-center gap-2 px-2 py-1 rounded bg-surface border border-border">
      <span className={`inline-block w-2 h-2 rounded-full ${color}`} />
      <span className="font-mono">{label}</span>
      {connected && bridge && bridge.connected && bridge.mt5_server && (
        <span className="text-fg-muted">· {bridge.mt5_server}</span>
      )}
    </span>
  );
}
